import styles from './App.module.css';
import ChatBotBubble from './components/ChatBotBubble/ChatBotBubble';
import Chat from './components/Chat/Chat';

import { useState, useEffect } from 'react';

function App() {
  const [data,setData]=useState([]);
  const [open, setOpen] = useState(false);
  function toggleOpenChat(){
    setOpen(!open);
  }
  const getData=()=>{
  fetch(process.env.PUBLIC_URL + '/messages.json'
      ,{
        headers : {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
         }
      }
      )
        .then(function(response){
          console.log(response)
          return response.json();
        })
        .then(function(myJson) {
          console.log(myJson);
          setData(() => [myJson])
        });
}
useEffect(()=>{

    getData()

    /* el chat se abre al cabo de 3 segundos */
    setTimeout(function(){
      toggleOpenChat();
    },3000)

  },[])

  return (
    <div className={styles.chatBot}>
    {data && data.length > 0 && <Chat open={open} messages={data[0]}/>}

      <ChatBotBubble open={open} toggleOpenChatFn={toggleOpenChat}/>
    </div>
  );
}

export default App;
